<template>
    <Modal :title="$t('customRating.manageRiskAssessmentModal.title')"
           width="600"
           :close-on-click-outside="false"
           @close="closeModal()"
    >
        <template v-slot:body>
            <form class="base_margin modal-content" style="margin-top: 0">
                <div class="text_left light_bg_color margin_top">
                    <span class="font_bold">{{$t("common.hint")}}：</span>
                    <br/>
                    <span>{{$t("customRating.manageRiskAssessmentModal.hintText")}}</span>
                </div>
                <div class="flex flex_start_bottom">
                    <md-checkbox v-model="form.showRating1" class="flex_1" style="padding-top: 5px">
                        {{$t('customRating.table.manageRiskAssessment.showRating1')}}
                    </md-checkbox>
                    <md-field class="flex_2">
                        <label>{{ $t("customRating.table.manageRiskAssessment.nameRating1") }}</label>
                        <md-input v-model="form.nameRating1"></md-input>
                    </md-field>
                </div>
                <div class="flex flex_start_bottom">
                    <md-checkbox v-model="form.showRating2" class="flex_1">
                        {{$t('customRating.table.manageRiskAssessment.showRating2')}}
                    </md-checkbox>
                    <md-field class="flex_2">
                        <label>{{ $t("customRating.table.manageRiskAssessment.nameRating2") }}</label>
                        <md-input v-model="form.nameRating2"></md-input>
                    </md-field>
                </div>
                <div class="flex flex_start_bottom">
                    <md-checkbox v-model="form.showRating3" class="flex_1">
                        {{$t('customRating.table.manageRiskAssessment.showRating3')}}
                    </md-checkbox>
                    <md-field class="flex_2">
                        <label>{{ $t("customRating.table.manageRiskAssessment.nameRating3") }}</label>
                        <md-input v-model="form.nameRating3"></md-input>
                    </md-field>
                </div>
            </form>
            <div class="flex flex_between">
                <md-button class="md-blank" @click="closeModal()">{{ $t("common.button.cancel") }}</md-button>
                <md-button
                    class="md-primary"
                    @click="submit"
                >{{ $t("common.button.submit") }}
                </md-button>
            </div>
        </template>
    </Modal>
</template>

<script>
import Modal from "@/components/templates/modal/Modal.vue";
import MoneyAmountInput from "@/components/templates/common/MoneyAmountInput.vue";

export default {
    components: {
        Modal,
        MoneyAmountInput,
    },
	props: {
		config: { type: Object, default: null }
	},
    data() {
        return {
            form: {
				showRating1: null,
				showRating2: null,
				showRating3: null,
				nameRating1: null,
				nameRating2: null,
				nameRating3: null,
            }
        };
    },
	beforeMount() {
		this.updateForm(this.config);
	},
    methods: {
	    updateForm(config) {
			this.form = {
				showRating1: config.showRating1,
				showRating2: config.showRating2,
				showRating3: config.showRating3,
				nameRating1: config.nameRating1,
				nameRating2: config.nameRating2,
				nameRating3: config.nameRating3
			};
	    },
        closeModal() {
            this.$emit("close");
        },
        submit() {
            this.$emit("submit", this.form)
        },
    },
	watch: {
		config() {
			this.updateForm(this.config);
		}
	}
};
</script>